<section class="weii-options-panel">
    <div *ngIf="showTitle"><h4 class="dropdown-header">Advanced calculation options</h4></div>

    <div *ngFor="let option of optionDefinitions" class="dropdown-item weii-option"
         [class.is-unavailable]="!isAvailable(option)">
        <div class="form-check mb-0 flex-grow-1">
            <input class="form-check-input" type="checkbox" [id]="optionId(option)"
                   [checked]="isChecked(option)" [disabled]="!isAvailable(option)"
                   (change)="setOption(option, $any($event.target).checked)">
            <label class="form-check-label" [for]="optionId(option)">
                <span>{{ option.label }}</span>
                <small *ngIf="optionCoverage(option) as optionCoverage" class="weii-option-coverage">
                    <span class="notranslate">{{optionCoverage.available}}/{{optionCoverage.total}}</span>
                    <span> locations have suitable data</span>
                </small>
            </label>
        </div>

        <app-widget-option-info
                [label]="option.label"
                [description]="option.description"
                [unavailableMessage]="!isAvailable(option) ? unavailableMessage(option) : null">
        </app-widget-option-info>
    </div>
</section>
